export const searchFormColumns = () => {
  return [
    {
      name: '公司名称',
      prop: 'companyName',
      type: 'input',
    },
    {
      name: '公司状态',
      prop: 'companyStatus',
      type: 'select',
      options: [
        {
          label: '已生效',
          value: '0',
        },
        {
          label: '已禁用',
          value: '1',
        },
      ],
    },
    {
      name: '部门名称',
      prop: 'departmentName',
      type: 'input',
    },
    {
      name: '部门状态',
      prop: 'departmentStatus',
      type: 'select',
      options: [
        {
          label: '已生效',
          value: '0',
        },
        {
          label: '已禁用',
          value: '1',
        },
      ],
    },
  ];
};
export const baseColumnListDefault = [
  {
    field: 'companyCode',
    title: '公司编码',
  },
  {
    field: 'companyName',
    title: '公司名称',
  },
  {
    field: 'companyStatus',
    title: '公司当前状态',
  },
  {
    field: 'departmentCode',
    title: '下属部门编码',
  },
  {
    field: 'departmentName',
    title: '部门名称',
  },
  {
    field: 'departmentStatus',
    title: '部门当前状态',
  },
];
